export default "/_next/static/images/addon-8a16823feee20135ef62113891b9070b.svg";